// // SearchDocList.js - Fixed version

// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import Select, { createFilter } from "react-select";
// import { connect } from "react-redux";
// import { useHistory } from "react-router-dom";
// import { doctorActions } from "../../core/actions";
// import { helperServices } from "../../shared/helper";
// import { patientActions } from "../../core/actions";
// import Card from "@mui/material/Card";
// import Button from "@mui/material/Button";
// import Components from "../index";
// import { DOCTOR_ROLE, RESET } from "../../shared/constants/index";
// import { format } from "date-fns";
// import personDetailsService from "../../core/services/personDetailsService";

// import { useOrganization } from "../../configurations/OrganizationContext";
// import { buildDoctorOption } from "../../shared/helper/helper";
// import {
// ORG_CODES
// } from "../../shared/constants";

// function SearchDocList(props) {
//   // console.log("propsss---", props);

//   const history = useHistory();
//   const org = useOrganization();

//   const [selectedOption, setSelectedOption] = useState();
//   const [deptId, setDeptId] = useState("");
//   const [options, setOption] = useState("");
//   const dispatch = useDispatch();

//   // Consultant related states
//   const [selectedConsultant, setSelectedConsultant] = useState(null);
//   const [consultantList, setConsultantList] = useState([]);
//   const [assignedConsultants, setAssignedConsultants] = useState([]);
//   const [consultantMessage, setConsultantMessage] = useState({
//     success: "",
//     error: "",
//   });

//   const [reload, setReload] = useState(false);
//   const [viewDoctorDetails, setviewDoctorDetails] = useState(false);
//   const [assignedDoctor, setassignedDoctor] = useState();
//   const [assignedDoctorEmail, setAssignedDoctorEmail] = useState("");
//   const [doctorList, setdoctorList] = useState([]);
//   const [showAppointmentModal, setShowAppointmentModal] = useState(false);
//   const [patientCalender, setPatientCalender] = useState([]);

//   // NEW STATE: Track if modal has been auto-opened for this patient
//   const [hasAutoOpenedModal, setHasAutoOpenedModal] = useState(false);
  
//   const patientVisitList = useSelector((state) => {
//     // console.log("karthik:", state.patientDetailsState.patientVisitLists);
//     return state.patientDetailsState.patientVisitLists;
//   });
//   const doctors = personDetailsService.getDoctorsDetail();

//   const getLatestDoctorAssignment = () => {
//     const assignments = patientVisitList?.[0]?.visitAssignmentList;
//     if (!assignments || !assignments.length) return null;
//     const latestOpen = [...assignments]
//       .reverse()
//       .find(
//         (a) =>
//           (a.groupname === "Primary Doctor" || a.groupname === "Primary Counsellor") &&
//           a.targetid &&
//           (a.status === "open" || a.status === "active" || a.status === undefined || a.status === null)
//       );
//     if (latestOpen) return latestOpen;
//     return [...assignments]
//       .reverse()
//       .find(
//         (a) =>
//           (a.groupname === "Primary Doctor" || a.groupname === "Primary Counsellor") &&
//           a.targetid
//       );
//   };

//   const getDoctorAssignmentTargetId = (assignment) =>
//     assignment?.targetid || assignment?.gvId || assignment?.gvid || assignment?.counselor;

//   const getDoctorNameFromTargetId = (targetId) => {
//     if (!targetId) return null;
//     const fullDoctor = doctors.find(
//       (doc) =>
//         doc?.gvId == targetId || doc?.gvid == targetId || doc?.personId == targetId
//     );
//     return fullDoctor ? buildDoctorOption(fullDoctor)?.label : null;
//   };

//   // Check if doctor is assigned
//   const isDoctorAssigned = () => {
//     // Prioritize visitAssignmentList (most recent server data) over props.docInfo
//     const primaryFromList_isDoctorAssigned = getLatestDoctorAssignment();
//     const docAssignment = primaryFromList_isDoctorAssigned ||
//       ((props.docInfo?.gvId || props.docInfo?.counselor) ? props.docInfo : null);
//     return (
//       Boolean(assignedDoctor) ||
//       Boolean(docAssignment) ||
//       Boolean(props.docInfo?.email)
//     );
//   };

//   useEffect(() => {
//     console.log("props in doctor:", props);
//     console.log("props in doctor::::", props.apptdate);
//     console.log("props of patientinfo:", patientVisitList);
//     console.log("props in Patientsection:", props.patientCalenderInfo);
//     console.log(
//       "props patient infooo",
//       props?.patientInfo,
//       "--",
//       patientVisitList[0]?.visit
//     );
//     getPatientCalender();
//     let gv = props?.docInfo?.["gvId"];

//     if (props.docInfo?.gvId && props.docInfo.gvId !== "") {
//       setviewDoctorDetails(true);
//     } else {
//       setviewDoctorDetails(false);
//     }

//     getassignedDoctorDetails();
//     setAssignedConsultants(getAssignedConsultants());

//     getConsultantList(); // Get consultant list

//     if (helperServices.CheckAccessLevel("InsurancePatients")) {
//       console.log("role is:", localStorage.getItem("role"));
//     }

//     if (
//       props.patientInfo &&
//       props.patientInfo.status &&
//       props.patientInfo.status === "close"
//     ) {
//       setviewDoctorDetails(true);
//     }

//     // FIXED: Only auto-open modal once per patient and only in specific conditions
//     const shouldAutoOpenModal =
//       props.patientInfo?.status !== "close" &&
//       !isDoctorAssigned() && // This checks if doctor is NOT assigned
//       props.apptdate &&
//       !hasAutoOpenedModal &&
//       props.from === "patienSection";

//     if (shouldAutoOpenModal && props.patientInfo?.status === "open") {
//       console.log(
//         "Auto-opening appointment modal - patient needs doctor assignment"
//       );
//       setShowAppointmentModal(true);
//       setHasAutoOpenedModal(true);
//     }

//     // Reset when patient changes OR when status is closed
//     const patientId = props.patientInfo?.id;
//     if (patientId !== previousPatientIdRef.current) {
//       setHasAutoOpenedModal(false);
//       if (props.patientInfo?.status === "close") {
//         setShowAppointmentModal(false);
//       }
//       previousPatientIdRef.current = patientId;
//     }
//   }, [props, patientVisitList, doctors, props.refreshKey]); // Added refreshKey prop to trigger refresh

//   useEffect(() => {
//     console.log(
//       "SearchDocList received docInfo prop update:",
//       JSON.stringify(props.docInfo)
//     );

//     // Prioritize visitAssignmentList (most recent open server data) over props.docInfo
//     const primaryFromList_useEffect = getLatestDoctorAssignment();
//     const docAssignment = primaryFromList_useEffect ||
//       ((props.docInfo?.gvId || props.docInfo?.counselor) ? props.docInfo : null);

//     if (docAssignment) {
//       setviewDoctorDetails(true);
//       getassignedDoctorDetails();
//       setAssignedConsultants(getAssignedConsultants());

//       const targetId = docAssignment.targetid || docAssignment.gvId || docAssignment.gvid || docAssignment.counselor;
//       const assignedDoctorInfo = doctors.find(
//         (doc) =>
//           doc?.gvId == targetId ||
//           doc?.gvid == targetId ||
//           doc?.personId == targetId
//       );

//       if (assignedDoctorInfo) {
//         const opt = buildDoctorOption(assignedDoctorInfo);
//         setSelectedOption(opt);
//         setassignedDoctor(opt.label);
//         setAssignedDoctorEmail(assignedDoctorInfo.email || "");
//       } else if (targetId) {
//         const resolvedName = getDoctorNameFromTargetId(targetId);
//         setassignedDoctor(
//           resolvedName ||
//           docAssignment.targetname ||
//           `Doctor ID: ${targetId}`
//         );
//         setAssignedDoctorEmail(docAssignment.email || "");
//       } else if (docAssignment.email || docAssignment.counselor || docAssignment.targetname) {
//         setassignedDoctor(
//           docAssignment.targetname || `Doctor ID: ${docAssignment.counselor || docAssignment.targetid}`
//         );
//         setAssignedDoctorEmail(docAssignment.email || "");
//       }
//     } else {
//       setassignedDoctor(null);
//       setAssignedDoctorEmail("");
//     }
//   }, [props.docInfo, patientVisitList, doctors]);

//   // Add ref to track patient changes
//   const previousPatientIdRef = React.useRef();

//   const getPatientCalender = () => {
//     let arr = [];
//     let patientId = props.patientInfo.patientId
//       ? props.patientInfo.patientId
//       : "";
//     let patCalender = [];

//     console.log("For patient details:", props.patientCalenderInfo);

//     if (
//       Array.isArray(props.patientCalenderInfo) &&
//       props.patientCalenderInfo.length > 0
//     ) {
//       props.patientCalenderInfo.forEach((obj, index) => {
//         Object.entries(obj).forEach(([key, value]) => {
//           console.log(`Value `, value);
//           if (key !== "id" && key !== "gvid" && key !== "date") {
//             if (value !== "") {
//               if (value === patientId.toString()) {
//                 console.log(
//                   "typeof patientId, typeof value",
//                   typeof patientId,
//                   typeof value
//                 );
//                 console.log(`Value  `, value);
//                 arr.push(obj);
//                 console.log(`Value in if`, arr);
//               }
//             }
//           }
//         });
//       });

//       patCalender = [...arr];
//       console.log("Patient calendar found:", patCalender);
//     } else {
//       console.log("props.patientCalenderInfo is not an array or has length 0");
//     }

//     setPatientCalender([...patCalender]);
//     console.log("Patient calendar found:", patientCalender);
//   };

//   // Get consultant list - similar to AddConsultant.js
//   const getConsultantList = () => {
//     const resCb = personDetailsService.getDoctorsDetail();
//     console.log("getConsultantList Response:", resCb);
//     if (!resCb) return;
//     const list = resCb
//       .filter((doc) => doc?.type?.toLowerCase() === "doctor")
//       .map(buildDoctorOption);
//     setConsultantList(list);
//     console.log("Consultant list Response:", list);
//   };

//   const getassignedDoctorDetails = () => {
//     let doctorList = doctors;
//     if (doctorList) {
//       console.log("doctorListyttt", doctorList);
//       doctorList = doctorList.filter((doc) => {
//         if (doc != null) {
//           console.log("doctorListyttt", doc);
//           return doc["type"].toLowerCase() === "doctor";
//         }
//         return false;
//       });
//       let deptOptions = [];
      
//       // Prioritize visitAssignmentList (most recent open server data) over props.docInfo
//       const primaryFromList_getAssigned = getLatestDoctorAssignment();
//       const docAssignment = primaryFromList_getAssigned ||
//         ((props.docInfo?.gvId || props.docInfo?.counselor) ? props.docInfo : null);

//       const targetId = docAssignment ? (docAssignment.targetid || docAssignment.gvId || docAssignment.gvid || docAssignment.counselor) : null;
//       const resolvedName = targetId ? getDoctorNameFromTargetId(targetId) : null;

//       for (let det of doctorList) {
//         const opt = buildDoctorOption(det);
//         deptOptions.push(opt);

//         if (
//           targetId &&
//           (targetId == det.gvId || targetId == det.gvid || targetId == det.personId)
//         ) {
//           setSelectedOption(opt);
//           setassignedDoctor(opt.label);
//           setAssignedDoctorEmail(det.email || "");
//           setReload(!reload);
//         }
//       }

//       // Always update doctor name from latest assignment data (don't check local state to avoid stale closures)
//       if (targetId) {
//         setassignedDoctor(resolvedName || docAssignment?.targetname || `Doctor ID: ${targetId}`);
//       }

//       setOption(deptOptions);
//     }
//   };

//   const handleChange = (selectedOption) => {
//     console.log("event", selectedOption);
//     setSelectedOption(selectedOption);
//     console.log("select option 2", selectedOption);
//     if (props.from == "appointment") {
//       // props.parentCallBack(selectedOption);
//     }
//   };

//   // Handle consultant selection
//   const handleConsultantChange = (selectedOption) => {
//     console.log("Selected consultant:", selectedOption);
//     setSelectedConsultant(selectedOption);
//   };

//   // Add consultant functionality - similar to AddConsultant.js submit function
//   const addConsultant = () => {
//     if (!selectedConsultant) {
//       setConsultantMessage({
//         success: "",
//         error: "Please select a consultant",
//       });
//       return;
//     }

//     let summary = {
//       patientId: props.patientInfo.patientId || props.patientInfo.id,
//       visitId:
//         props.patientInfo.visitId ||
//         (patientVisitList[0] && patientVisitList[0].visit.id),
//       groupname: "Consultant",
//       shortdesc: "Added " + selectedConsultant.label + " " + "as consultant",
//       longdesc: "Consultant assigned via doctor assignment section",
//       targetid: selectedConsultant.id,
//       role: selectedConsultant.role,
//     };

//     console.log("Consultant details to be sent:", summary);

//     let consultant = summary.role;
//     consultant = consultant.charAt(0).toUpperCase() + consultant.slice(1);

//     dispatch(
//       doctorActions.addConsultant(summary, consultant, "", (resCb) => {
//         if (resCb) {
//           console.log("addConsultant Response:", resCb);
//           if (resCb.successMessages) {
//             setConsultantMessage({
//               success: "Consultant Assigned Successfully.",
//               error: "",
//             });
//             // Add to assigned consultants list
//             setAssignedConsultants((prev) => [...prev, selectedConsultant]);
//             setSelectedConsultant(null); // Reset selection
//           } else {
//             setConsultantMessage({
//               success: "",
//               error: "Failed to Assign Consultant.",
//             });
//           }
//         }
//       })
//     );
//   };

//   const toggle = () => {
//     setviewDoctorDetails(!viewDoctorDetails);
//   };

//   const handleSubmit = () => {
//     console.log("selected option:", selectedOption);
//     if (selectedOption != null) {
//       props.parentCallBack(selectedOption);
//     }
//   };

//   // Navigate to booking plans page with patient info
//   const openBookingPlan = () => {
//     const patientInfo = props.patientInfo;
//     if (!patientInfo) {
//       return;
//     }

//     const patientName = patientInfo.fname || patientInfo.first_name || patientInfo.name || 'Patient';
//     const patientId = patientInfo.patientId || patientInfo.id || '';
//     const visitId = patientInfo.visitId || (patientVisitList[0] && patientVisitList[0].visit && patientVisitList[0].visit.id) || '';
    
//     // Get assigned doctor from visit assignments - prioritize visitAssignmentList (most recent server data)
//     const primaryFromList_openBooking = getLatestDoctorAssignment();
//     const doctorAssignment = primaryFromList_openBooking ||
//       ((props.docInfo?.gvId || props.docInfo?.counselor) ? props.docInfo : null);
    
//     // Get room assignment from visit assignments
//     const roomAssignment = patientVisitList[0]?.visitAssignmentList?.find(a => a.groupname === "Room");
    
//     // Build navigation state with doctor and room info
//     const navigationState = {
//       selectedPatient: {
//         id: patientInfo.id || patientInfo.patientId,
//         patient_name: patientName,
//         fname: patientName,
//         phone: patientInfo.phno || patientInfo.phoneno || '',
//       },
//       from: 'patientAppointment',
//       returnTo: `/PatientSections/${patientId}/${visitId}`,
//     };
//     // Add doctor info if assigned (for edit mode) - pass the full doctor object
//     if (doctorAssignment || (props.lastassigned && (props.lastassigned.doctorId || props.lastassigned.gvId || props.lastassigned.gvid || props.lastassigned.personId))) {
//       const targetId = doctorAssignment 
//         ? (doctorAssignment.targetid || doctorAssignment.gvId || doctorAssignment.gvid || doctorAssignment.counselor)
//         : (props.lastassigned.doctorId || props.lastassigned.gvId || props.lastassigned.gvid || props.lastassigned.personId);
      
//       if (targetId) {
//         // Find the full doctor object from the doctors list
//         const fullDoctor = doctors.find(doc => 
//           doc.personId == targetId || 
//           doc.gvId == targetId ||
//           doc.gvid == targetId
//         );
        
//         // Build doctor name from available properties
//         const doctorName = assignedDoctor || (fullDoctor ? buildDoctorOption(fullDoctor)?.label : null) || props.lastassigned?.doctor || `Doctor ${targetId}`;
        
//         navigationState.doctor = {
//           id: targetId,
//           name: doctorName,
//           doctorData: fullDoctor // Pass the full doctor object for reference
//         };
//       }
//     }
    
//     // Add room info if assigned
//     if (roomAssignment) {
//       navigationState.room = {
//         id: roomAssignment.targetid,
//         name: roomAssignment.targetname || `Room ${roomAssignment.targetid}`,
//         roomData: roomAssignment // Pass the full room assignment object
//       };
//     }
    
//     console.log('[SearchDocList] Navigating with state:', navigationState);
    
//     history.push({
//       pathname: `/PatientSections/${patientId}/${visitId}/new-booking`,
//       state: navigationState,
//     });
//   };

//   const closeAppntmentModal = (event) => {
//     console.log("close appointment modal:", event);
//     props.onModalClose(event);
//     setShowAppointmentModal(false);
//   };

//   const getFormattedDate = (date) => {
//     const reqdate = new Date(date);
//     let formatteddate = format(reqdate, "MMM dd yyyy");
//     return formatteddate;
//   };

//   const getAssignedConsultants = () => {
//     if (!patientVisitList || patientVisitList.length === 0) return [];

//     const visitAssignmentList = patientVisitList[0]?.visitAssignmentList || [];

//     // Filter only consultant assignments
//     const consultantAssignments = visitAssignmentList.filter(
//       (assignment) =>
//         assignment.groupname === "Consultant" && assignment.targetid
//     );

//     const consultants = consultantAssignments
//       .map((assignment) =>
//         doctors.find((doc) => doc?.personId === assignment.targetid)
//       )
//       .filter(Boolean) // remove nulls
//       .map(buildDoctorOption);

//     return consultants;
//   };

//   const latestAssignedDoctorLabel = (() => {
//     const latestAssignment = getLatestDoctorAssignment();
//     const targetId = getDoctorAssignmentTargetId(latestAssignment);
//     if (latestAssignment && targetId) {
//       return (
//         getDoctorNameFromTargetId(targetId) ||
//         latestAssignment.targetname ||
//         `Doctor ID: ${targetId}`
//       );
//     }
//     return props.lastassigned?.doctor || null;
//   })();

//   return (
//     <main key={reload} className={props.rootClassName || ""}>
//       {props && props.patientInfo && props.patientInfo.status != "preReg" ? (
//         <Card
//           className={`mb-1 p-2 text-center ${
//             org?.orgCode === ORG_CODES.MNH &&
//             props?.patientInfo?.status !== "close" &&
//             !props?.activeSection?.includes("Insurance")
//               ? "card-with-consultant"
//               : " "
//           } ${props.cardClassName || ""}`}
//         >
//           <div
//             h6
//             className="d-flex justify-content-center align-items-center gap-2"
//           >
//             <h6 className="mt-2">Doctor Appointment Details</h6>

//             {/* FIXED: Only show edit icon when doctor is assigned */}
//             {org?.isEditIcon?.display &&
//               props?.patientInfo?.status !== "close" &&
//               !props?.activeSection?.includes("Insurance") &&
//               isDoctorAssigned() && (
//                 <i
//                   className="material-icons"
//                   style={{ cursor: "pointer", fontSize: "18px" }}
//                   title="Edit"
//                   onClick={openBookingPlan}
//                 >
//                   edit
//                 </i>
//               )}
//           </div>

//           {assignedDoctor ? (
//             <>
//               <label className="mb-1">
//                 <span className="text-muted" style={{ fontWeight: 500 }}>{assignedDoctor}</span>
//               </label>
//               {assignedDoctorEmail ? (
//                 <div>
//                   <span className="text-muted" style={{ fontSize: "12px" }}>
//                     {assignedDoctorEmail}
//                   </span>
//                 </div>
//               ) : null}
//               {patientCalender.map((calenderItem) => (
//                 <span style={{ display: "block" }} className="text-muted">
//                   {calenderItem.date}
//                 </span>
//               ))}
//               <div>
//                 {latestAssignedDoctorLabel ? (
//                   <label>
//                     <span className="text-muted">
//                       Last Assigned :&nbsp;
//                       {latestAssignedDoctorLabel}
//                     </span>
//                   </label>
//                 ) : (
//                   ""
//                 )}
//               </div>
//             </>
//           ) : (
//             <div>
//               <label className="text-center">No doctors assigned.</label>
//             </div>
//           )}
//           <div>
//  {/* FIXED: Only show assign doctor button when no doctor is assigned */}
//             {props?.patientInfo?.status != "close" &&
//               !props?.activeSection?.includes("Insurance") &&
//               !isDoctorAssigned() && (
//                 <Button
//                   className="btn-primary btn-sm m-auto"
//                   variant="contained"
//                   color="primary"
//                   sx={{ textTransform: "capitalize" }}
//                   onClick={(event) =>  openBookingPlan()}
//                 >
//                   Assign Doctor
//                 </Button>
//               )}
//           </div>
//           {/* <div>
//             <Button
//               className="btn-primary btn-sm m-auto"
//               variant="contained"
//               color="primary"
//               sx={{ textTransform: "capitalize" }}
//               onClick={() => openBookingPlan()}
//             >
//               Assign Doctor
//             </Button>
//           </div>

//           {/* Consultant Section */}
//           {org?.orgCode === ORG_CODES.MNH &&
//             props?.patientInfo?.status != "close" &&
//             !props?.activeSection?.includes("Insurance") && (
//               <div className="mt-3">
//                 <div className="d-flex align-items-center gap-2 mb-3">
//                   <Select
//                     className="select-tag flex-grow-1"
//                     name="Search Consultant"
//                     value={selectedConsultant}
//                     onChange={handleConsultantChange}
//                     isClearable
//                     isSearchable
//                     options={consultantList}
//                     filterOption={createFilter(consultantList)}
//                     placeholder="Select Consultant..."
//                   />
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     size="small"
//                     sx={{ textTransform: "capitalize" }}
//                     onClick={addConsultant}
//                   >
//                     Add Consultant
//                   </Button>
//                 </div>

//                 {assignedConsultants.length > 0 && (
//                   <div className="mt-2">
//                     <h6 className="mb-2">Assigned Consultants:</h6>
//                     {assignedConsultants.map((consultant, index) => (
//                       <div
//                         key={index}
//                         className="text-muted"
//                         style={{ fontSize: "14px", marginBottom: "5px" }}
//                       >
//                         {consultant.label}
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             )}
//         </Card>
//       ) : (
//         ""
//       )}

//       {showAppointmentModal &&
//         patient List.length > 0 &&
//         props.patientInfo?.status === "open" && (
//           <>
//             <Components.AppointmentScheduleModal
//               patientData={patientVisitList[0]}
//               type="Doctor"
//               doctorInfo={props.docInfo}
//               onModalClose={(event) => closeAppntmentModal(event)}
//             />
//           </>
//         )}
//     </main>
//   );
// }

// export default SearchDocList;
// SearchDocList.js - Fully Fixed & Optimized version

import React, { useState, useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select, { createFilter } from "react-select";
import { useHistory } from "react-router-dom";
import { doctorActions } from "../../core/actions";
import { helperServices } from "../../shared/helper";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Components from "../index";
import personDetailsService from "../../core/services/personDetailsService";
import { format } from "date-fns";

import { useOrganization } from "../../configurations/OrganizationContext";
import { buildDoctorOption } from "../../shared/helper/helper";
import { ORG_CODES } from "../../shared/constants";
import { bookingPlanService } from "../../core/services/bookingplanService";

function SearchDocList(props) {
  const history = useHistory();
  const org = useOrganization();
  const dispatch = useDispatch();

  // Add ref to track patient changes at the top
  const previousPatientIdRef = useRef();

  const [selectedOption, setSelectedOption] = useState(null);
  const [options, setOption] = useState([]);

  // Consultant related states
  const [selectedConsultant, setSelectedConsultant] = useState(null);
  const [consultantList, setConsultantList] = useState([]);
  const [assignedConsultants, setAssignedConsultants] = useState([]);
  const [consultantMessage, setConsultantMessage] = useState({
    success: "",
    error: "",
  });

  const [viewDoctorDetails, setviewDoctorDetails] = useState(false);
  const [assignedDoctor, setassignedDoctor] = useState(null);
  const [assignedDoctorEmail, setAssignedDoctorEmail] = useState("");
  const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  const [patientCalender, setPatientCalender] = useState([]);
  // booking_plans record with groupname='assigndoctor' for this patient/visit -
  // holds the doctor assignment's own start_date/start_time/end_time, which stays
  // stable across later "new session" bookings (unlike visit.apptdate/appthours,
  // which every session/booking update overwrites).
  const [assignedDoctorBooking, setAssignedDoctorBooking] = useState(null);

  // Track if modal has been auto-opened for this patient
  const [hasAutoOpenedModal, setHasAutoOpenedModal] = useState(false);
  
  const patientVisitList = useSelector((state) => {
    return state.patientDetailsState.patientVisitLists;
  });
  
  // getDoctorsDetail() JSON.parse's sessionStorage, which creates a new array on
  // every render. Keep one stable reference so the effect below does not loop.
  const doctors = useMemo(() => {
    if (Array.isArray(props.doctors)) return props.doctors;
    return personDetailsService.getDoctorsDetail() || [];
  }, [props.doctors]);

  // The API is called with type=showAllVisits, so the selected visit is not
  // guaranteed to be the first item in patsearchreslt.
  const currentVisit = useMemo(() => {
    if (!Array.isArray(patientVisitList) || patientVisitList.length === 0) {
      return null;
    }

    const selectedVisitId = props.patientInfo?.visitId;
    if (selectedVisitId === null || selectedVisitId === undefined || selectedVisitId === "") {
      return patientVisitList[0];
    }

    return (
      patientVisitList.find((item) => {
        const itemVisitId = item?.visit?.id ?? item?.visitId;
        return String(itemVisitId) === String(selectedVisitId);
      }) || null
    );
  }, [patientVisitList, props.patientInfo?.visitId]);

  const visitAssignments = useMemo(() => {
    const directAssignments = currentVisit?.visitAssignmentList;
    const nestedAssignments = currentVisit?.visit?.visitAssignmentList;

    if (Array.isArray(directAssignments)) return directAssignments;
    if (Array.isArray(nestedAssignments)) return nestedAssignments;
    return [];
  }, [currentVisit]);

  // Fetch the booking_plans row (groupname='assigndoctor') for this patient/visit so
  // the appointment date/time shown here reflects when the doctor was actually
  // assigned, instead of visit.apptdate/appthours which every session booking overwrites.
  useEffect(() => {
    const patientId = props.patientInfo?.patientId;
    const visitId = currentVisit?.visit?.id ?? currentVisit?.visitId ?? props.patientInfo?.visitId;
    if (!patientId) {
      setAssignedDoctorBooking(null);
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        const response = await bookingPlanService.getBookingPlanByPatientId(patientId, true, visitId);
        const plan = response?.data?.data || response?.data || response;
        if (!cancelled) {
          setAssignedDoctorBooking(plan && typeof plan === "object" ? plan : null);
        }
      } catch (err) {
        console.warn("Failed to fetch assigndoctor booking plan:", err);
        if (!cancelled) setAssignedDoctorBooking(null);
      }
    })();

    return () => { cancelled = true; };
  }, [props.patientInfo?.patientId, currentVisit]);

  const normalizeValue = (value) => value?.toLowerCase().trim() || "";

  const isDoctorAssignment = (assignment) => {
    const rawGroup = assignment?.groupname;
    const group = normalizeValue(rawGroup);
    const type = normalizeValue(assignment?.type);

    // Only treat the explicit assign-doctor row as the assigned doctor.
    // Session creation rows such as "new session" are shown in Session Details
    // and must not populate the Doctor Appointment card.
    return (
      type === "doctor" &&
      (rawGroup == null || group === "")
    );
  };

  const isRoomAssignment = (assignment) => {
    const group = normalizeValue(assignment?.groupname);
    const type = normalizeValue(assignment?.type);
    return group === "room" || type === "room";
  };

  // Robust, case-insensitive check for doctor assignments
  const getLatestDoctorAssignment = () => {
    if (visitAssignments.length === 0) return null;

    const latestOpen = [...visitAssignments]
      .reverse()
      .find(
        (a) =>
          isDoctorAssignment(a) &&
          ((a.targetid !== null && a.targetid !== undefined) || a.gvId || a.gvid || a.counselor) &&
          (normalizeValue(a.status) === "open" || normalizeValue(a.status) === "active" || !a.status)
      );

    if (latestOpen) return latestOpen;

    return [...visitAssignments]
      .reverse()
      .find(
        (a) => isDoctorAssignment(a) && (a.targetid || a.gvId || a.gvid || a.counselor)
      );
  };

  const getDoctorAssignmentTargetId = (assignment) =>
    assignment?.targetid ??
    assignment?.gvId ??
    assignment?.gvid ??
    assignment?.counselor ??
    assignment?.personId;

  const getResolvedDoctorSource = () => {
    const assignment = getLatestDoctorAssignment();
    if (assignment) return assignment;

    /*const visitDoctor = currentVisit?.person;
    if (visitDoctor?.gvId || visitDoctor?.gvid || visitDoctor?.personId) {
      return visitDoctor;
    }*/ 

    // Do not reuse docInfo from the previous patient while the selected visit
    // is still loading.
    if (props.patientInfo?.visitId && !currentVisit) return null;

    if (props.docInfo?.gvId || props.docInfo?.gvid || props.docInfo?.counselor || props.docInfo?.personId) {
      return props.docInfo;
    } 

    return null;
  };

  const getLatestRoomAssignment = () => {
    if (visitAssignments.length === 0) return null;

    const latestActiveRoom = [...visitAssignments]
      .reverse()
      .find(
        (assignment) =>
          isRoomAssignment(assignment) &&
          (assignment?.targetid || assignment?.targetname)
      );

    if (latestActiveRoom) return latestActiveRoom;

    return [...visitAssignments]
      .reverse()
      .find(
        (assignment) => isRoomAssignment(assignment) && (assignment?.targetid || assignment?.targetname)
      ) || null;
  };

  const getDoctorNameFromTargetId = (targetId) => {
    if (!targetId) return null;
    const fullDoctor = doctors.find(
      (doc) => doc?.gvId == targetId || doc?.gvid == targetId || doc?.personId == targetId
    );
    return fullDoctor ? buildDoctorOption(fullDoctor)?.label : null;
  };

  const isDoctorAssigned = () => {
    const docAssignment = getResolvedDoctorSource();
    const result = (
      Boolean(docAssignment) ||
      Boolean(props.docInfo?.email)
    );
    // DEBUG: Log the assignment check
    console.log('[SearchDocList] isDoctorAssigned check:', {
      result,
      docAssignment,
      docAssignmentKeys: docAssignment ? Object.keys(docAssignment) : [],
      targetid: docAssignment?.targetid,
      gvId: docAssignment?.gvId,
      gvid: docAssignment?.gvid,
      counselor: docAssignment?.counselor,
      personId: docAssignment?.personId,
      propsDocInfo: props.docInfo,
      propsDocInfoEmail: props.docInfo?.email,
      visitAssignments: visitAssignments,
      currentVisit: currentVisit,
    });
    return result;
  };

  const getPatientCalender = () => {
    let arr = [];
    let patientId = props.patientInfo?.patientId ? props.patientInfo.patientId : "";

    if (Array.isArray(props.patientCalenderInfo) && props.patientCalenderInfo.length > 0) {
      props.patientCalenderInfo.forEach((obj) => {
        Object.entries(obj).forEach(([key, value]) => {
          if (key !== "id" && key !== "gvid" && key !== "date" && value !== "") {
            if (value === patientId.toString()) {
              arr.push(obj);
            }
          }
        });
      });
    }
    setPatientCalender([...arr]);
  };

  const getConsultantList = () => {
    if (!doctors) return;
    const list = doctors
      .filter((doc) => doc?.type?.toLowerCase() === "doctor")
      .map(buildDoctorOption);
    setConsultantList(list);
  };

  const getAssignedConsultants = () => {
    const consultantAssignments = visitAssignments.filter(
      (assignment) => assignment.groupname === "Consultant" && assignment.targetid
    );

    return consultantAssignments
      .map((assignment) => doctors.find((doc) => doc?.personId === assignment.targetid))
      .filter(Boolean)
      .map(buildDoctorOption);
  };

  // ONE UNIFIED EFFECT: Safely handles synchronized data flow
  useEffect(() => {
    // 1. Sync Calendar & Consultants
    getPatientCalender();
    getConsultantList();
    setAssignedConsultants(getAssignedConsultants());
    console.log("Propssss",props)

    if (helperServices.CheckAccessLevel("InsurancePatients")) {
      console.log("role is:", localStorage.getItem("role"));
    }

    // 2. Resolve Doctor Assignments safely
    const docAssignment = getResolvedDoctorSource();

    if (docAssignment) {
      setviewDoctorDetails(true);

      const targetId = getDoctorAssignmentTargetId(docAssignment);
      const assignedDoctorInfo = doctors.find(
        (doc) => doc?.gvId == targetId || doc?.gvid == targetId || doc?.personId == targetId
      );

      if (assignedDoctorInfo) {
        const opt = buildDoctorOption(assignedDoctorInfo);
        setSelectedOption(opt);
        setassignedDoctor(opt.label);
        setAssignedDoctorEmail(assignedDoctorInfo.email || "");
      } else if (targetId) {
        const resolvedName = getDoctorNameFromTargetId(targetId);
        const responseDoctorName = [
          docAssignment.displaytitle,
          docAssignment.first_name || docAssignment.firstName,
          docAssignment.last_name || docAssignment.lastName,
        ]
          .filter(Boolean)
          .join(" ")
          .trim();
        setassignedDoctor(
          resolvedName ||
          docAssignment.targetname ||
          responseDoctorName ||
          `Doctor ID: ${targetId}`
        );
        setAssignedDoctorEmail(docAssignment.email || "");
      } else if (docAssignment.email || docAssignment.counselor || docAssignment.targetname) {
        setassignedDoctor(docAssignment.targetname || `Doctor ID: ${docAssignment.counselor || docAssignment.targetid}`);
        setAssignedDoctorEmail(docAssignment.email || "");
      }
    } else {
      setassignedDoctor(null);
      setAssignedDoctorEmail("");
      setviewDoctorDetails(false);
    }

    if (props.patientInfo?.status === "close") {
      setviewDoctorDetails(true);
    }

    // Populate overall dropdown options list
    if (doctors.length > 0) {
      const filteredDoctors = doctors.filter((doc) => doc && doc["type"]?.toLowerCase() === "doctor");
      setOption(filteredDoctors.map(buildDoctorOption));
    }

    // 3. Auto-open modal rules
    const hasAssignedDoc = Boolean(docAssignment) || Boolean(props.docInfo?.email);
    const shouldAutoOpenModal =
      Boolean(currentVisit) &&
      props.patientInfo?.status !== "close" &&
      !hasAssignedDoc &&
      props.apptdate &&
      !hasAutoOpenedModal &&
      props.from === "patienSection";

    if (shouldAutoOpenModal && props.patientInfo?.status === "open") {
      setShowAppointmentModal(true);
      setHasAutoOpenedModal(true);
    }

    // 4. Reset tracker when patient switching occurs
    const patientId = props.patientInfo?.id;
    if (patientId !== previousPatientIdRef.current) {
      setHasAutoOpenedModal(false);
      if (props.patientInfo?.status === "close") {
        setShowAppointmentModal(false);
      }
      previousPatientIdRef.current = patientId;
    }
  }, [
    props.docInfo, 
    props.patientInfo, 
    props.apptdate, 
    props.from, 
    props.refreshKey, 
    props.patientCalenderInfo, 
    patientVisitList, 
    currentVisit,
    visitAssignments,
    doctors,
    hasAutoOpenedModal
  ]);

  const handleConsultantChange = (selectedOption) => {
    setSelectedConsultant(selectedOption);
  };

  const addConsultant = () => {
    if (!selectedConsultant) {
      setConsultantMessage({ success: "", error: "Please select a consultant" });
      return;
    }

    let summary = {
      patientId: props.patientInfo?.patientId || props.patientInfo?.id,
      visitId: props.patientInfo?.visitId || currentVisit?.visit?.id || currentVisit?.visitId,
      groupname: "Consultant",
      shortdesc: "Added " + selectedConsultant.label + " as consultant",
      longdesc: "Consultant assigned via doctor assignment section",
      targetid: selectedConsultant.id,
      role: selectedConsultant.role,
    };

    let consultant = summary.role || "doctor";
    consultant = consultant.charAt(0).toUpperCase() + consultant.slice(1);

    dispatch(
      doctorActions.addConsultant(summary, consultant, "", (resCb) => {
        if (resCb && resCb.successMessages) {
          setConsultantMessage({ success: "Consultant Assigned Successfully.", error: "" });
          setAssignedConsultants((prev) => [...prev, selectedConsultant]);
          setSelectedConsultant(null);
        } else {
          setConsultantMessage({ success: "", error: "Failed to Assign Consultant." });
        }
      })
    );
  };

  const openBookingPlan = async () => {
    const patientInfo = props.patientInfo;
    if (!patientInfo) return;

    const patientName = patientInfo.fname || patientInfo.first_name || patientInfo.name || 'Patient';
    const patientId = patientInfo.patientId || patientInfo.id || '';
    const visitId = patientInfo.visitId || currentVisit?.visit?.id || currentVisit?.visitId || '';
    
    const doctorAssignment = getResolvedDoctorSource();
    const roomAssignment = getLatestRoomAssignment();
    
    // Get the visitassignment ID from the latest doctor assignment
    const latestDoctorAssignment = getLatestDoctorAssignment();
    const visitAssignmentId = latestDoctorAssignment?.id || null;
    
    // Build navigation state
    const navigationState = {
      selectedPatient: {
        id: patientInfo.id || patientInfo.patientId,
        patient_name: patientName,
        fname: patientName,
        phone: patientInfo.phno || patientInfo.phoneno || '',
        visitId: patientInfo.visitId || currentVisit?.visit?.id || currentVisit?.visitId || '',
        // Preserve the visit state when BookingNewSession updates appointment
        // fields. Without this, its partial visit update sends null.
        internalStatus:
          patientInfo.internalStatus || currentVisit?.visit?.internalStatus || null,
        visit: currentVisit?.visit || patientInfo.visit || null,
      },
      from: 'patientAppointment',
      returnTo: `/PatientSections/${patientId}/${visitId}`,
      visitInternalStatus:
        patientInfo.internalStatus || currentVisit?.visit?.internalStatus || null,
      visitAssignmentId: visitAssignmentId,  // Pass visitassignment table ID
    };

    if (doctorAssignment) {
      const targetId = getDoctorAssignmentTargetId(doctorAssignment);
      if (targetId) {
        const fullDoctor = doctors.find(doc => doc?.personId == targetId || doc?.gvId == targetId);
        const doctorName = assignedDoctor || (fullDoctor ? buildDoctorOption(fullDoctor)?.label : null) || `Doctor ${targetId}`;

        navigationState.doctor = { id: targetId, name: doctorName, doctorData: fullDoctor };
      }
    }
    
    if (roomAssignment) {
      navigationState.room = {
        id: roomAssignment.targetid,
        name: roomAssignment.targetname || `Room ${roomAssignment.targetid}`,
        roomData: roomAssignment,
      };
    } else if (props.lastassigned?.roomId || props.lastassigned?.room) {
      navigationState.room = {
        id: props.lastassigned.roomId,
        name: props.lastassigned.room || `Room ${props.lastassigned.roomId}`,
        roomData: props.lastassigned.roomData,
      };
    }
    
    // An existing visit must always stay in the existing-visit flow. Edit mode
    // controls whether an existing booking plan is updated; it must not make
    // the visit look new.
    const isEditMode = isDoctorAssigned();

    history.push({
      pathname: `/PatientSections/${patientId}/${visitId}/new-booking`,
      state: {
        ...navigationState,
        mode: isEditMode ? "EDIT_DOCTOR" : "ASSIGN_DOCTOR",
        hasOpenVisit: Boolean(visitId),
        existingVisitId: visitId,
        groupname: null,  // null groupname tells backend to close previous open visitassignment records
      }
    });
  };

  const closeAppntmentModal = (event) => {
    props.onModalClose?.(event);
    setShowAppointmentModal(false);
  };

  const latestAssignedDoctorLabel = (() => {
    const latestAssignment = getLatestDoctorAssignment();
    const targetId = getDoctorAssignmentTargetId(latestAssignment);
    if (latestAssignment && targetId) {
      return getDoctorNameFromTargetId(targetId) || latestAssignment.targetname || `Doctor ID: ${targetId}`;
    }
    return null;
  })();

  const latestAssignedRoomLabel = (() => {
    const latestAssignment = getLatestRoomAssignment();
    if (latestAssignment) {
      return latestAssignment.targetname || (latestAssignment.targetid ? `Room ${latestAssignment.targetid}` : null);
    }
    const roomData = props.lastassigned?.roomData;
    if (roomData) {
      return roomData.roomName || roomData.name || roomData.label || roomData.targetname || roomData.targetName || (roomData.id ? `Room ${roomData.id}` : null);
    }
    return props.lastassigned?.room || null;
  })();

  const pad = (v) => (v === null || v === undefined ? "" : String(v).padStart(2, "0"));

  const formatTimeFromParts = (hours, minutes) => {
    if ((hours === null || hours === undefined || hours === "") && (minutes === null || minutes === undefined || minutes === "")) return "";
    const h = Number(hours);
    const m = Number(minutes || 0);
    if (Number.isNaN(h) || Number.isNaN(m)) return "";
    const period = h >= 12 ? "PM" : "AM";
    let hour12 = h % 12;
    if (hour12 === 0) hour12 = 12;
    return `${hour12}:${String(m).padStart(2, "0")} ${period}`;
  };

  // Extract "HH:mm" from either a plain "HH:mm" string or a full ISO timestamp
  // (e.g. "2024-01-01T10:30:00.000+00:00" or "2024-01-01 10:30:00.0").
  const extractHHmm = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const str = String(value).trim();
    // Match HH:mm anywhere in the string (handles ISO timestamps too)
    const match = str.match(/(\d{1,2}):(\d{2})/);
    if (!match) return "";
    return `${match[1].padStart(2, "0")}:${match[2]}`;
  };

  const formatVisitDateTime = (visit) => {
    if (!visit) return "";
    // Date
    const rawDate = visit.apptdate || visit.capptdate || visit.reqtdate || visit.visitDate || visit.start_date || visit.date;
    let dateStr = rawDate ? (() => { try { return format(new Date(rawDate), "MMM dd yyyy"); } catch (e) { return rawDate; } })() : "";

    // Start / end times - try several common fields
    const startCandidates = [visit.start_time, visit.startTime, visit.appthours ? pad(visit.appthours) + ":" + pad(visit.apptminutes) : null, visit.appthours ? pad(visit.appthours) + ":00" : null];
    const endCandidates = [visit.end_time, visit.endTime, visit.endtime, visit.endtime_val, visit.endTimeVal];

    let startRaw = startCandidates.find((s) => s);
    let endRaw = endCandidates.find((s) => s);

    // If start is provided as separate parts (appthours, apptminutes) use that formatting
    if (!startRaw && (visit.appthours || visit.apptminutes)) {
      startRaw = pad(visit.appthours) + ":" + pad(visit.apptminutes || 0);
    }

    // Normalize "HH:mm" or ISO timestamp => display 12-hour
    const to12 = (timeStr) => {
      if (!timeStr) return "";
      const hhmm = extractHHmm(timeStr);
      if (!hhmm) return timeStr;
      const parts = hhmm.split(":");
      const hh = Number(parts[0]);
      const mm = Number(parts[1] || 0);
      if (Number.isNaN(hh) || Number.isNaN(mm)) return timeStr;
      const period = hh >= 12 ? "PM" : "AM";
      let hour12 = hh % 12;
      if (hour12 === 0) hour12 = 12;
      return `${hour12}:${String(mm).padStart(2, "0")} ${period}`;
    };

    const startDisplay = startRaw ? to12(startRaw) : "";
    const endDisplay = endRaw ? to12(endRaw) : "";

    if (dateStr && startDisplay && endDisplay) return `${dateStr} — ${startDisplay} - ${endDisplay}`;
    if (dateStr && startDisplay) return `${dateStr} — ${startDisplay}`;
    if (dateStr) return dateStr;
    if (startDisplay) return startDisplay;
    return "";
  };

  return (
    <main className={['h-100', 'd-flex', 'flex-column', props.rootClassName || ''].filter(Boolean).join(' ')}>
      {props && props.patientInfo && props.patientInfo.status !== "preReg" ? (
        <Card
          style={props.cardStyle}
          className={`mb-1 p-2 text-center h-100 w-100 ${
            org?.orgCode === ORG_CODES.MNH &&
            props?.patientInfo?.status !== "close" &&
            !props?.activeSection?.includes("Insurance")
              ? "card-with-consultant"
              : " "
          } ${props.cardClassName || ""}`}
        >
          <div
            className="d-flex justify-content-center align-items-center gap-2"
            style={props.headerStyle}
          >
            <h6
              className="mt-2"
              style={{
                color: props.headingColor,
                ...(props.headingStyle || {}),
              }}
            >
              Doctor Appointment Details
            </h6>
            {/* DEBUG: Edit button condition */}
            {(() => {
              const editCondition = (org?.isEditIcon?.display ?? true) &&
                props?.patientInfo?.status !== "close" &&
                !props?.activeSection?.includes("Insurance") &&
                isDoctorAssigned();
              console.log('[SearchDocList] Edit button condition check:', {
                editCondition,
                orgIsEditIconDisplay: org?.isEditIcon?.display,
                patientInfoStatus: props?.patientInfo?.status, 
                activeSection: props?.activeSection,
                includesInsurance: props?.activeSection?.includes("Insurance"),
                isDoctorAssignedResult: isDoctorAssigned(),
              });
              return editCondition;
            })() && (
              <i
                className="material-icons"
                style={{ cursor: "pointer", fontSize: "18px" }}
                title="Edit"
                onClick={openBookingPlan}
              >
                edit
              </i>
            )}
          </div>

          {assignedDoctor ? (
            <>
              <label className="mb-1">
                <span className="text-muted" style={{ fontWeight: 500 }}>{assignedDoctor}</span>
              </label>
              {assignedDoctorEmail ? (
                <div>
                  <span className="text-muted" style={{ fontSize: "12px" }}>{assignedDoctorEmail}</span>
                </div>
              ) : null}
              {(() => {
                // Prefer the assigndoctor booking_plans row's own date/time (stable,
                // set when the doctor was assigned) over visit.apptdate/appthours,
                // which every later session booking overwrites.
                const visitObj = assignedDoctorBooking || currentVisit?.visit || currentVisit || null;
                const apptText = formatVisitDateTime(visitObj);
                if (apptText) {
                  return (
                    <span style={{ display: "block" }} className="text-muted">{apptText}</span>
                  );
                }

                return patientCalender.map((calenderItem, idx) => (
                  <span key={idx} style={{ display: "block" }} className="text-muted">
                    {calenderItem.date}
                  </span>
                ));
              })()}
              {/* <div>
                {latestAssignedDoctorLabel && (
                  <label>
                    <span className="text-muted">Last Assigned :&nbsp;{latestAssignedDoctorLabel}</span>
                  </label>
                )}
                {latestAssignedRoomLabel && (
                  <label style={{ display: "block" }}>
                    <span className="text-muted">Last Room :&nbsp;{latestAssignedRoomLabel}</span>
                  </label>
                )}
              </div> */}

              {/* {latestAssignedDoctorLabel ? (
                <div>
                  <label>
                    <span className="text-muted">
                      Last Assigned :&nbsp;{latestAssignedDoctorLabel}
                    </span>
                  </label>
                </div>
              ) : null} */}
            </>
          ) : (
            <div className="doctor-assignment-empty-state">
              <label className="text-center">No doctors assigned.</label>
            </div>
          )}
          
          <div className="doctor-assignment-action">
            {/* DEBUG: Assign Doctor button condition */}
            {(() => {
              const assignCondition = props?.patientInfo?.status !== "close" &&
                !props?.activeSection?.includes("Insurance") &&
                !isDoctorAssigned();
              console.log('[SearchDocList] Assign Doctor button condition check:', {
                assignCondition,
                patientInfoStatus: props?.patientInfo?.status,
                activeSection: props?.activeSection,
                includesInsurance: props?.activeSection?.includes("Insurance"),
                isDoctorAssignedResult: isDoctorAssigned(),
              });
              return assignCondition;
            })() && (
                <Button
                  className="btn-primary btn-sm m-auto"
                  variant="contained"
                  color="primary"
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => openBookingPlan()}
                >
                  Assign Doctor
                </Button>
              )}
          </div>

          {/* Consultant Section */}
          {org?.orgCode === ORG_CODES.MNH &&
            props?.patientInfo?.status !== "close" &&
            !props?.activeSection?.includes("Insurance") && (
              <div className="mt-3">
                <div className="d-flex align-items-center gap-2 mb-3">
                  <Select
                    className="select-tag flex-grow-1"
                    name="Search Consultant"
                    value={selectedConsultant}
                    onChange={handleConsultantChange}
                    isClearable
                    isSearchable
                    options={consultantList}
                    filterOption={createFilter(consultantList)}
                    placeholder="Select Consultant..."
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    sx={{ textTransform: "capitalize" }}
                    onClick={addConsultant}
                  >
                    Add Consultant
                  </Button>
                </div>

                {assignedConsultants.length > 0 && (
                  <div className="mt-2">
                    <h6 className="mb-2">Assigned Consultants:</h6>
                    {assignedConsultants.map((consultant, index) => (
                      <div key={index} className="text-muted" style={{ fontSize: "14px", marginBottom: "5px" }}>
                        {consultant.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
        </Card>
      ) : (
        ""
      )}

      {showAppointmentModal &&
        currentVisit &&
        props.patientInfo?.status === "open" && (
          <Components.AppointmentScheduleModal
            patientData={currentVisit}
            type="Doctor"
            doctorInfo={props.docInfo}
            onModalClose={closeAppntmentModal}
          />
        )}
    </main>
  );
}

export default SearchDocList;
